import h from "./general-masks/telephone-libphonenumber-mask.js";
import d from "./general-masks/iban-mask.js";
import g from "./general-masks/numeric-mask.js";
import v from "./general-masks/smscode-mask.js";
import { useFormStore as z } from "../../stores/form.js";
import { storeToRefs as F } from "pinia";
import S from "./countries-masks/ar.js";
import A from "./countries-masks/at.js";
import E from "./countries-masks/au.js";
import L from "./countries-masks/be.js";
import Z from "./countries-masks/br.js";
import T from "./countries-masks/ca.js";
import j from "./countries-masks/ch.js";
import C from "./countries-masks/cl.js";
import J from "./countries-masks/co.js";
import R from "./countries-masks/cr.js";
import y from "./countries-masks/cz.js";
import I from "./countries-masks/de.js";
import V from "./countries-masks/dk.js";
import W from "./countries-masks/ec.js";
import q from "./countries-masks/es.js";
import B from "./countries-masks/fi.js";
import D from "./countries-masks/fr.js";
import G from "./countries-masks/gb.js";
import H from "./countries-masks/gr.js";
import K from "./countries-masks/gt.js";
import N from "./countries-masks/hk.js";
import P from "./countries-masks/hu.js";
import Y from "./countries-masks/id.js";
import O from "./countries-masks/ie.js";
import Q from "./countries-masks/il.js";
import U from "./countries-masks/in.js";
import X from "./countries-masks/it.js";
import _ from "./countries-masks/jp.js";
import ee from "./countries-masks/kr.js";
import re from "./countries-masks/lt.js";
import ae from "./countries-masks/lu.js";
import te from "./countries-masks/mx.js";
import oe from "./countries-masks/my.js";
import se from "./countries-masks/nl.js";
import me from "./countries-masks/no.js";
import ce from "./countries-masks/nz.js";
import ie from "./countries-masks/pe.js";
import ke from "./countries-masks/ph.js";
import pe from "./countries-masks/pl.js";
import ne from "./countries-masks/pt.js";
import be from "./countries-masks/ro.js";
import fe from "./countries-masks/se.js";
import le from "./countries-masks/sg.js";
import Me from "./countries-masks/sv.js";
import ue from "./countries-masks/th.js";
import $e from "./countries-masks/tr.js";
import he from "./countries-masks/tw.js";
import ge from "./countries-masks/us.js";
import xe from "./countries-masks/vn.js";
import we from "./countries-masks/za.js";
const Fr = async (o) => {
  let e;
  switch (o) {
    case "ar":
      e = S;
      break;
    case "at":
      e = A;
      break;
    case "au":
      e = E;
      break;
    case "be":
      e = L;
      break;
    case "br":
      e = Z;
      break;
    case "ca":
      e = T;
      break;
    case "ch":
      e = j;
      break;
    case "cl":
      e = C;
      break;
    case "co":
      e = J;
      break;
    case "cr":
      e = R;
      break;
    case "cz":
      e = y;
      break;
    case "de":
      e = I;
      break;
    case "dk":
      e = V;
      break;
    case "ec":
      e = W;
      break;
    case "es":
      e = q;
      break;
    case "fi":
      e = B;
      break;
    case "fr":
      e = D;
      break;
    case "gb":
      e = G;
      break;
    case "gr":
      e = H;
      break;
    case "gt":
      e = K;
      break;
    case "hk":
      e = N;
      break;
    case "hu":
      e = P;
      break;
    case "id":
      e = Y;
      break;
    case "ie":
      e = O;
      break;
    case "il":
      e = Q;
      break;
    case "in":
      e = U;
      break;
    case "it":
      e = X;
      break;
    case "jp":
      e = _;
      break;
    case "kr":
      e = ee;
      break;
    case "lt":
      e = re;
      break;
    case "lu":
      e = ae;
      break;
    case "mx":
      e = te;
      break;
    case "my":
      e = oe;
      break;
    case "nl":
      e = se;
      break;
    case "no":
      e = me;
      break;
    case "nz":
      e = ce;
      break;
    case "pe":
      e = ie;
      break;
    case "ph":
      e = ke;
      break;
    case "pl":
      e = pe;
      break;
    case "pt":
      e = ne;
      break;
    case "ro":
      e = be;
      break;
    case "se":
      e = fe;
      break;
    case "sg":
      e = le;
      break;
    case "sv":
      e = Me;
      break;
    case "th":
      e = ue;
      break;
    case "tr":
      e = $e;
      break;
    case "tw":
      e = he;
      break;
    case "us":
      e = ge;
      break;
    case "vn":
      e = xe;
      break;
    case "za":
      e = we;
      break;
  }
  return e;
}, de = (o, e, i, c) => {
  const k = e.replace(/[^a-zA-Z0-9+]/g, "");
  switch (o) {
    case "telephoneLibphonenumber":
      return new h().telephone(k, i.value);
    case "telephoneLibphonenumberWithoutTrailingZero":
      return new h().telephone(k, i.value, !0);
    case "zipcode":
      return c.value.zipcode(e);
    case "birthdate":
      return c.value.birthdate();
    case "birthYear":
      return new g().numeric(c.value.decimalSeparator, 4);
    case "iban":
      return new d().iban(e);
    case "numeric":
      return new g().numeric(c.value.decimalSeparator);
    case "smscode":
      return new v().smscode();
  }
}, Sr = (o, e) => {
  const i = z(), { countryCode: c, countryMaskFile: k } = F(i);
  let r = e.value, l = !1, s = de(o, r, c, k);
  if (!o) return r;
  (o === "telephoneLibphonenumber" || o === "telephoneLibphonenumberWithoutTrailingZero") && (l = !0);
  let m = r.replace(/[^a-zA-Z0-9+\uFF10-\uFF19]/g, ""), n = e.selectionStart, M = "^", p = [];
  const x = {
    a: "[a-zA-Z]",
    9: "[0-9+]",
    0: "0",
    1: "[0-1]",
    2: "[0-2]",
    3: "[0-3]",
    "*": "[0-9a-zA-Z]",
    J: "[0-9０-９]",
    " ": "\\s",
    "-": "-"
  };
  if (s.match(/^\//)) {
    s = s.replace(/^\/+|\/+$/g, "");
    let a = new RegExp(s);
    const t = r.length - 1;
    return r.match(a) || (r = r.slice(0, t)), r;
  }
  for (let a = 0; a < s.length; a++) {
    let t = s.charAt(a);
    (t === " " || t === "-") && p.push([a, t]);
  }
  for (let a = 0; a < p.length; a++) {
    const t = p[a][0], f = p[a][1];
    m = m.slice(0, t) + f + m.slice(t);
  }
  m = m.replace(/^-+|-+$/g, ""), m = m.trim(), r = m;
  for (let a = 0; a < r.length; a++) {
    let t = s.charAt(a);
    const f = x[t];
    M += f;
    let w = new RegExp(M);
    if (!r.match(w))
      return r = r.slice(0, a), r;
  }
  const u = s.replace(/-|\s/g, ""), $ = r.replace(/-|\s/g, "");
  let b = u.charAt($.length) || u.charAt($.length - 1);
  return parseInt(b) || b === "J" || b === "" ? (e.type = "tel", e.inputMode = l ? "tel" : "numeric") : (e.type = "text", e.inputMode = "text"), e.selectionStart = n, e.selectionStart !== e.selectionEnd && (e.selectionStart = n + 1, e.selectionEnd = n + 1), r;
};
export {
  Fr as getCountryMaskFile,
  de as getMask,
  Sr as useMask
};
